export default "__VITE_ASSET__34b819c7__"